import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { CommonService } from 'src/app/services/common.service';
import { LookupOptionsData } from '../../jurisdiction.domain';
import { AllDropdownKeys } from '../../jurisdiction.constants';

@Component({
  selector: 'app-development-area',
  templateUrl: './development-area.component.html',
  styleUrls: ['./development-area.component.scss'],
})
export class DevelopmentAreaComponent implements OnInit {
  devAreaKey: string = AllDropdownKeys.DevelopmentAreaName;
  devAreaTypes: LookupOptionsData[] = this.commonService.getDropdownData(this.devAreaKey);
  devAreaName: string = '';

  get isLookupValue(): boolean {
    return this.devAreaTypes.some(type => type.value === this.devAreaName);
  }

  constructor(private commonService: CommonService, private localStorageService: LocalStorageService) {}

  ngOnInit(): void {
    const locationData = this.commonService.locationData || this.localStorageService.getItem('location_data') || {};
    this.devAreaName = (locationData.newDevArea && locationData.devAreaName) || '';
  }
}
